<div *ngIf="appointment.EventType==1 || appointment.EventType==2||appointment.EventType==5" class="appointment-card base-color w-100">
    <span class="labelColor" [style.background-color]="appointment.LabelColor"></span>
    <div class="card-header" fxLayoutAlign="center center">
        <span class="scheduler-color-circle" [style.background-color]="appointment.ScdColor"></span>
        <span class="pr-2 pl-2" fxFlex>
            <span *ngIf="appointment.EventType === 5">{{ 'COMMON.HOLIDAY' | translate }}</span>
            <span *ngIf="appointment.EventType === 2">{{ 'COMMON.REMARK' | translate }} | </span>
            <span *ngIf="appointment.ScdName">{{appointment.ScdName}}&nbsp;</span>
            <span *ngIf="appointment.BranchName">({{appointment.BranchName}})</span></span>
        <app-appointment-menu [appointment]="appointment" 
            (delete)="onDelete($event)"
            (confirmed)="onConfirm($event)" 
            (paid)="onPaid($event)"
            (captureImage)="onCaptureImageClick($event)"
            (uploadDocument)="onUploadDocumentClick($event)"
            (paymentRequest)="onPaymentRequest($event)"
            (sendOrFillForm)="onSendOrFillForm($event)"
            *ngIf="appointment.EventType === 1"></app-appointment-menu>
    </div>
    <span class="seperator"></span>
    <div class="card-content" fxLayout="row">
        <div fxFlex="0 0 20px">&nbsp;</div>
        <!-- must set overflow:hidden here -->
        <div fxFlex="1 1 auto" fxLayout="column" style="overflow: hidden;">
            <div class="clientName mt-1" title="{{appointment.EventID}}">{{appointment.Title}}
                <span *ngIf="appointment.Gender !== 0">({{ appointment.Gender == 1 ? ('GENDER.M' | translate) :
                    ('GENDER.F' | translate)}})</span>
            </div>
            <div>
                <span>{{ appointment.Start | amDateFormat: 'ddd' }}</span>
                <span style="margin:0 11px;">|</span>
                <span>{{ appointment.Start | amDateFormat: 'L' }}</span>
                <span style="margin:0 11px;"  *ngIf="appointment.EventType !== 5">|</span>
                <span *ngIf="appointment.EventType !== 5">{{ appointment.Start | amDateFormat: 'LT'}}-{{ appointment.End | amDateFormat: 'LT'}}</span>
            </div>
            <div>
                <div fxLayout="row">
                    <div *ngIf="appointment.EventType !== 2" class="column stretch nowrap">
                        <span>{{ visitReasonSummary() }}</span>
                        <ng-template #noPermissionTemplate>
                            <div>{{ 'COMMON.NO-PERMISSION' | translate }}</div>
                        </ng-template>
                    </div>

                    <div *ngIf="appointment.EventType == 2">
                        <span>{{ appointment.Description }}</span>
                        <div *ngIf="appointment.AssociatedCustomers">
                            <div *ngFor="let customer of appointment.AssociatedCustomers; index as i; trackbyFn">
                                <div>{{ customer.Name }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="column fixed">
                        <span *ngIf="appointment.Arrived" class="ic-status ic-status-arrived"></span>
                        <span *ngIf="appointment.NoShow" class="ic-status ic-status-not-arrived"></span>
                        <span *ngIf="appointment.Confirmed === confirmeAppointmentType.Confirmed" class="ic-status ic-status-confirmed"></span>
                        <span *ngIf="appointment.Confirmed === confirmeAppointmentType.ConfirmedOnlineByPatient" class="ic-status ic-status-confirmed-online"></span>
                        <span *ngIf="appointment.Confirmed === confirmeAppointmentType.Decline" class="ic-status ic-status-decline"></span>
                        <span *ngIf="appointment.Paid" class="ic-status ic-status-paid"></span>
                        <span *ngIf="appointment.Description && appointment.EventType != 2" class="ic-status ic-status-remark"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="appointment.EventType==3" class="block-section">
    <span class="ic-lock-lite"></span>
    <span style="padding: 0 7px;">
        <span *ngIf="appointment.Description" style="display: inline-block;">{{appointment.Description}}</span>
        <span *ngIf="appointment.Description" style="margin:0 11px;">|</span>
        <span *ngIf="appointment.ScdName" style="display: inline-block;">{{appointment.ScdName}},&nbsp;</span>       
        <span *ngIf="appointment.BranchName" style="display: inline-block;">{{appointment.BranchName}}&nbsp;&nbsp;</span> 
        <span style="margin:0 11px;">|</span>  
        <span>{{ appointment.Start | amDateFormat: 'ddd' }}</span>
        <span style="margin:0 11px;">|</span>    
        <span>{{ appointment.Start | amDateFormat: 'LT'}}-{{ appointment.End | amDateFormat: 'LT'}}</span>
    </span>
</div>

